export const FORM_REGISTER = 'FORM_REGISTER'
export const FORM_REGISTER_ERR = 'FORM_REGISTER_ERR'